export default __webpack_public_path__ + "static/media/linetech_logo.87bc2a6c.png";